import React from 'react';
import {Divider} from 'semantic-ui-react';

const PageWidgetDivider = () => <Divider className="huge-tm large-bm" />;

export default PageWidgetDivider;
